// extracted by mini-css-extract-plugin
export default {"main":"main--6aaec551","toolbar":"toolbar--af3e5b9e","content":"content--dbbad732","navigation":"navigation--93943883","prev":"prev--8f062b74","next":"next--1623c556"};